import React from 'react';
import { PriceBanner } from '@gjensidige/se-price-banner';
import { PriceCard } from '@gjensidige/se-price-card';
import { useAppSelector } from '../hooks/appHooks';
import { getSelectedPackages } from '../store/slices/offerSlice';
import { Coupon, TotalPriceInfo, Package } from '../interfaces/Types';
import { AppConstants } from '../utils/AppConstants';
import {
  discountResolver,
  calculateFinalYearlyDiscount,
  discountResolverWithCouponCode
} from '../utils/Calculation/CalculationService';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { TextHelper } from '../utils/TextHelper';
import { ConfigHelper } from '../utils/ConfigHelper';
import { DiscountHelper } from '../utils/DiscountHelper';

interface ITotalPriceContainerProp {
  stickToTop?: boolean;
}

export const TotalPriceContainer: React.FC<ITotalPriceContainerProp> = (
  props: ITotalPriceContainerProp
) => {
  const selectedPackages = useAppSelector(getSelectedPackages);
  const selectedInsurancePackage = selectedPackages.find(
    (packageItem: Package) => !packageItem.isPlusPackage
  );
  const discountPercentage = useAppSelector(
    (state) => state.insurance.offer.discountPercentage
  );
  const offerInfo = useAppSelector((state) => state.insurance.offer);
  const totalPriceInfo: TotalPriceInfo =
    InsuranceHelper.getTotalPriceInfoFromSelection(
      selectedPackages,
      offerInfo.productName
    );
  const isUpdateOfferInProgress = useAppSelector(
    (state) => state.insurance.loading === 'updating'
  );
  const couponInfo: Coupon = useAppSelector(
    (state) => state.insurance.offer.coupon
  );
  const channel = offerInfo.channel || InsuranceHelper.getChannelInfo();

  
  const getTotalPrice = () => {
    return totalPriceInfo.totalPrice > 0
      ? `${totalPriceInfo.totalPrice.toLocaleString('sv-SE')} ${
          totalPriceInfo.currency
        }`
      : selectedPackages.length > 0
      ? '-'
      : '';
  };
  const getPaymentTerm = () => {
    if (totalPriceInfo.totalPrice > 0) {
      return AppConstants.getAppText(
        'webshop.totalPrice.payementFrequecy.label'
      );
    }
    return '';
  };
  const getSelectedPackageLabel = () =>
    selectedPackages.length > 0
      ? totalPriceInfo.selectedPackageLabels.join(' + ')
      : '';
  const getCentreTitle = () =>
    selectedPackages.length > 0 && selectedInsurancePackage?.isEnabled
      ? ''
      : AppConstants.getAppText(
          'webshop.villa.packageSelectionDefaultBannerText'
        )

  const discountsDetails = DiscountHelper.buildDiscountDetails(
    offerInfo.productName,
    channel.toLowerCase(),
    discountPercentage,
    couponInfo
  );
  const discountsList = discountsDetails.map(discount => parseInt(discount.value));

  const totalYearlyDiscount = calculateFinalYearlyDiscount( totalPriceInfo.totalPrice, discountsList) || 0;

  return (
    <>
      {
        selectedPackages.length > 0 && !props.stickToTop ? (
          <PriceCard
            descriptionTitle={AppConstants.getAppText(
              'webshop.totalPrice.label.selected'
            )}
            title={totalPriceInfo.selectedPackageLabels.join(' + ')}
            price={getTotalPrice()} //"430 kr"
            period={getPaymentTerm()} //"/mån"
            priceLabel={totalYearlyDiscount > 0 ?'Pris efter rabatter' : ''}
            totalDiscountTitle={AppConstants.getAppText(
              'webshop.discount.total.label'
            )}
            totalDiscountYearly={`${totalYearlyDiscount.toLocaleString(
              'sv-SE'
            )} ${totalPriceInfo.currency}/år`}
            isPriceLoading={isUpdateOfferInProgress}
            discountsList={discountsDetails}
          />
        ) : 
        (
          props.stickToTop && 
            <PriceBanner
              wrapperClassName="total-price-wrapper"
              packageSelected={getSelectedPackageLabel()}
              isUpdateInProgress={isUpdateOfferInProgress}
              totalPriceWithCurrency={getTotalPrice()}
              paymentFrequency={getPaymentTerm()}
              shouldStickToTop={true}
              centerTitle={getCentreTitle()}
            />
        )
      }
    </>
  );
};
